import React, { useState } from 'react'
import Scorer from '../ui/Scorer';
import { Button } from '../Buttons/Button';
import { showErrorToast } from '../ui/Toast';
import StyledCard from '../Cards/StyledCard';

function RoundReview({ roundNumber, candidate, onSubmit ,rounded = "bottom"}) {

  const roundedClass =  rounded === "bottom" ? 'rounded-b-xl' : rounded === "top" ? "rounded-t-xl" : "rounded-xl"   

    const [rating, setRating] = useState(0);
    const [feedback, setFeedback] = useState('');
  
    const handleSubmit = () => {
        if(rating < 1){
        showErrorToast("Oopss","Please rate the candidate");
        return
        }
      onSubmit(candidate._id, {
        jobId: candidate.currentApplication?.jobId ? candidate.currentApplication.jobId  : candidate.jobApplication.jobId ,
        stage: `Round ${roundNumber}`,
        ratings: rating,
        feedback,
      });
    };
  
  
    return (
      <StyledCard padding={2} backgroundColor={'bg-background-80'} borderRadius={roundedClass} extraStyles=' flex gap-4 justify-between  items-center'>
        <span className='flex-shrink-0'>{`Round ${roundNumber} ratings`}</span>
        <Scorer value={rating} onChange={setRating} />
  
        <input
          type="text"
          className='w-full bg-background-80  p-2 rounded'
          placeholder='Enter Your Feedback'
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
        />
        <Button variant="icon" onClick={handleSubmit}>Submit</Button>
      </StyledCard>
    );
  };

export default RoundReview;
